module.exports = __webpack_public_path__ + "static/img/365_09_01.5f799bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/365_09_01.png
// module id = /s7/
// module chunks = 3